import * as React from 'react';
import styles from '../../../styles/flyouts/plan_setting_templates/Properties.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import { __, validateForm } from '../../../core/utils';
import { connect } from 'react-redux';
import { subscribe } from 'react-contextual';
import Localization from '../../../helpers/Localization';
import classNames from 'classnames';
import EditBOQForm from '../../../forms/boq/EditBOQForm';
import EditPlanSettingTemplateForm from '../../../forms/plans/EditPlanSettingTemplateForm';
import { updatePlanSettingTemplates } from '../../../redux/actions/table/plan_setting_templates';

const Properties = ({ table, collapsed, data }) => {
  const _handleSubmit = (formData) => {
    const id = table.clicked_row;

    return validateForm(
      updatePlanSettingTemplates(data.id, formData).then(() => {
        props.readAction(formData.id);

        setNotification(__('boq.properties.saved'));
      })
    );
  };

  return (
    <div className={classNames(styles.wrapper, collapsed && styles.collapsed)}>
      <EditPlanSettingTemplateForm
        onSubmit={_handleSubmit}
        data={data}
        initialValues={{
          ..._.pick(data, [
            'id',
            'name',
            'cells',
            'grid_columns_count',
            'grid_rows_count',
          ]),
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    table: state.table['plan_setting_templates'],
    language_id: state.auth.language_id,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(subscribe(Localization, 'localization')(Properties))
);
